<template>
  <validation-observer
    ref="observer"
    v-slot="{invalid, pristine}"
    tag="form"
    class="footer-item__news"
    @submit.prevent="submit">
    <validation-provider>
      <div>
        <h3 class="newsletter-footer-header">
          {{ tStatic('footerNewsletterHeader') }}
          <a :name="tStatic('footerNewsletterAnchor')"></a>
        </h3>
        <p>
          {{ tStatic('newsletterFooterDescription') }}
        </p>
      </div>
    </validation-provider>

    <!--Villkorskryss-->
    <validation-provider
      v-slot="{ errors }"
      name="Terms"
      rules="required"
      slim>
      <oie-base-radio-checkbox
        v-model="acceptTerms"
        :errors="errors"
        class="input-colum__checkbox"
        required
        :label-html="true"
        :label="tStatic('approveTermsLabel')">
      </oie-base-radio-checkbox>
    </validation-provider>

    <validation-provider
      v-slot="{errors}"
      rules="required"
      mode="passive"
      slim>
      <oie-recaptcha-v2
        v-if="interacted"
        ref="recaptcha"
        v-model="recaptchaResponse"
        class="footer-newsletter__recaptcha"
        :errors="errors">
      </oie-recaptcha-v2>
    </validation-provider>

    <!--E-postfält-->
    <validation-provider
      v-slot="{ errors}"
      name="email"
      rules="required|email"
      slim>
      <div class="footer-newsletter--container">
        <oie-base-input-v2
          ref="subscribe"
          v-model="email"
          class="footer-newsletter__input"
          :aria-label="tStatic('footerNewsletterPlaceholder')"
          :placeholder="tStatic('footerNewsletterPlaceholder')"
          :errors="errors"
          required
          maxlength="100">
        </oie-base-input-v2>
        <button disabled class="button-newsletter--initial base-action base-action--primary base-action--large">
          <span>Skicka</span>
        </button>
        <oie-base-action
          v-if="!invalid && !pristine && acceptTerms && recaptchaResponse"
          v-element-loader="{ endpoint: 'newsletter/subscribe' }"
          type="submit"
          class="['footer-newsletter', { 'footer-newsletter--has-value': false}]"
          size="large">
          {{ tStatic('sendButton') }}
        </oie-base-action>
      </div>
    </validation-provider>
    <div :class="['input__message']">
      <template>
        <div v-if="errorMessage" class="input__message--error">
          {{ errorMessage }}
        </div>
      </template>

      {{ message }}
    </div>
  </validation-observer>
</template>

<script>
import httpService from '@/core/http-service'

export default {

  data() {
    return {
      email: '',
      acceptTerms: false,
      message: null,
      errorMessage: null,
      recaptchaResponse: null,
      interacted: false
    }
  },
  watch: {
    email() {
      this.interacted = true
    },
    acceptTerms(value) {
      this.interacted = true
    }
  },
  methods: {
    submit() {
      this.$refs.observer.validate().then((valid) => {
        if(valid) {
          httpService.post('newsletter/subscribe', { email: this.email, recaptchaResponse: this.recaptchaResponse }).then((response) => {
            this.$refs.recaptcha.reset()
            if(response.data.success) {
              this.errorMessage = ''
              this.message = response.data.information
              setTimeout(() => {
                this.email = ''
                this.acceptTerms = false
                this.message = null
                this.$refs.observer.reset()
              }, 6000)
            } else {
              this.errorMessage = response.data.information
              setTimeout(() => {
                this.errorMessage = ''
                this.message = null
              }, 6000)
            }
          })
            .catch((error) => {
              console.error('failed register email', error)
            })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .footer-item__news {
    @include media(medium) {
    max-width: 492px;
    margin-right: 1rem;
    }
  }
  .newsletter-footer-header {
    margin-bottom: measure(quarter);
  }
.footer-newsletter {
  position:relative;
  display: flex;
  align-items: center;
  background-color: color(background-white);
  border-radius: other(border-radius);
  overflow: hidden;
  width: 100%;

  @include media(large) {
    max-width: 30rem;
    margin-right: 100px;
  }
}
.button-newsletter--initial {
  z-index: 10;
  display: flex;
  align-items: center;
  border-radius: other(border-radius);
  overflow: hidden;

  @include media(large) {
    max-width: 30rem;
  }
}
.footer-newsletter--container {
  position:relative;
  padding-bottom: 2rem;
  @include media(x-small) {
    padding-bottom: 0;
  }
}
.footer-newsletter--container ::v-deep label {
  display: none !important;
}
.footer-newsletter--container button {
  position: absolute;
  right: 1px;
  top: 55px;
  @include media(x-small) {
    right: 5px;
    top: 5px;
  }
}
.footer-newsletter--container button + button {
  z-index: 20;
}
.footer-newsletter__input {
  position: relative;
  flex-grow: 1;
  // height: 3.5rem;
  border: none;
  // padding: 0 measure(half);

  /*
  @include media(medium) {
    height: 4rem;
  }
  */

  &::placeholder {
    @include caption;
    color: color(footer-headline);
  }

  &::-webkit-input-placeholder {
    @include caption;
    color: color(footer-headline);
  }

  &:-ms-input-placeholder {
    @include caption;
    color: color(footer-headline);
  }
}
.footer-newsletter__input input{
  padding-right: 115px;
}
.footer-newsletter__icon {
  width: 2.125rem;
  height: 1.5625rem;
  margin-left: measure(half);
  color: color(footer-headline);
}

.footer-newsletter__submit-action {
  @include reset-button;
  display: flex;
  justify-content: center;
  height: 4rem;
  padding: measure(half);
  border-radius: 0 0.1875rem 0.1875rem 0;
}

.footer-newsletter__submit-action--has-value {
  opacity: 1;
  background-color: color(button-action-green);
}

.footer-newsletter__submit-action--has-value:disabled {
  opacity: .6;
}

.footer-newsletter__submit-action--has-value .footer-newsletter__action-icon {
  color: white;
}
.footer-newsletter__recaptcha {
  margin-bottom: measure(quarter);
}
</style>
